export function classify(prefix: string) {
  return (classname: string) => `${prefix}-${classname}`;
}

export const is = classify('is');
export const has = classify('has');
